import React from 'react';

export interface CreditRequestCardT {
  icon: JSX.Element;
  companyName: string;
  onClick: any;
}

const CreditRequestCard = ({ icon, companyName, onClick }: CreditRequestCardT) => {
  return (
    <button type="button" className="credit-request-card" onClick={onClick} aria-label="button-card">
      <div className="credit-request-card__icon">{icon}</div>
      <h3 className="credit-request-card__company-name">{companyName}</h3>
    </button>
  );
};

export default CreditRequestCard;
